'use client';

import { useEffect } from 'react';

import { StepData, GalleryImageType } from '@/types/restResponses/steps';

/**
 * Custom hook for updating media URLs in development environment
 * Replaces cdn.pkb.local with cdn.help.prusa3d.com for all gallery items
 */
export function useMediaUrlUpdate(steps: StepData[]) {
  const updateMediaUrls = function (data: StepData[]) {
    data.forEach(item => {
      if (item.media?.gallery) {
        item.media.gallery.forEach((galleryItem: GalleryImageType) => {
          updateUrlsInGalleryItem(galleryItem);
          if (galleryItem.child) {
            updateUrlsInGalleryItem(galleryItem.child);
          }
        });
      }
    });
    return data;
  };

  function updateUrlsInGalleryItem(item: GalleryImageType) {
    const updateUrl = (url: string) => url.replace('cdn.pkb.local', 'cdn.help.prusa3d.com');

    ['original', 'medium', 'large', 'thumbnail', 'medium_large', '1536x1536'].forEach(key => {
      if (item[key]) item[key] = updateUrl(item[key]);
    });

    if (item.srcset) {
      item.srcset = item.srcset
        .split(', ')
        .map((src: string) => updateUrl(src))
        .join(', ');
    }
  }

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      updateMediaUrls(steps);
    }
  }, [steps]);
}
